import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchRequests } from '../https/requests';

// Shared constants fetched from loan-service (/loans/v2/config).
// Persisted via redux-persist so the app still works if the gateway
// is briefly unreachable on the next load.
export const fetchConfig = createAsyncThunk('config/fetch', async (_, { rejectWithValue }) => {
    try {
        const res = await fetchRequests('/loans/v2/config', 'GET', { 'Content-Type': 'application/json' }, {}, {});
        if (res?.err) return rejectWithValue(res.err);
        return res;
    } catch (err) {
        return rejectWithValue(err?.message || 'Failed to fetch config');
    }
});

const initialState = {
    version: null,
    config: null,
    loading: false,
    lastFetched: null,
    error: null,
};

const configSlice = createSlice({
    name: 'config',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchConfig.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchConfig.fulfilled, (state, action) => {
                state.loading = false;
                state.version = action.payload?.version ?? null;
                state.config = action.payload?.config ?? null;
                state.lastFetched = Date.now();
            })
            .addCase(fetchConfig.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error?.message || 'Unknown error';
            });
    },
});

// Selectors
export const selectConfig = (state) => state.config?.config;
export const selectConfigVersion = (state) => state.config?.version;
export const selectConfigLoading = (state) => state.config?.loading;
export const selectConfigError = (state) => state.config?.error;

export const selectProcessingFees = (state) => state.config?.config?.processingfees;
export const selectLoanInterestRate = (state) => state.config?.config?.loanInterestRate;
export const selectLoanAmtLimits = (state) => state.config?.config?.loanAmtLimits;
export const selectLoanTypes = (state) => state.config?.config?.loanTypes;
export const selectLoanStates = (state) => state.config?.config?.loanStates;
export const selectOptions = (state) => state.config?.config?.options;
export const selectLabels = (state) => state.config?.config?.labels;

export default configSlice.reducer;
